import { ACCESS_TOKEN } from "./constants";
import { logout } from "../../user/domain/userSlice";


export const request = (options, dispatch) => {
    const headers = new Headers({
        "Content-Type": "application/json",
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append(
            "Authorization",
            "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        );
    }

    const defaults = { headers: headers };
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
        .then((response) => response.json())
        .then((json) => {
            if (json.status === 401) {
                localStorage.removeItem(ACCESS_TOKEN);
                dispatch(logout());
                return {
                    ...json,
                    error: true,
                    process: 'failed',
                    content: []

                };
            }

            return { error: false, ...json };
        }).catch((err) => {
            console.error(err)
        })
};

export const requestFile = (options, dispatch) => {
    const headers = new Headers();

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append(
            "Authorization",
            "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        );
    }

    const defaults = { headers: headers };
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
        .then((response) => response.json())
        .then((json) => {
            if (json.status === 401) {
                localStorage.removeItem(ACCESS_TOKEN);
                dispatch(logout());
                return {
                    ...json,
                    error: true,
                    process: 'failed',
                    content: []

                };
            }

            return { error: false, ...json };
        }).catch((err) => {
            console.error(err)
        })
};

export const requestBlob = (options, dispatch) => {
    const headers = new Headers();

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append(
            "Authorization",
            "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        );
    }

    const defaults = { headers };
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
        .then((response) => {
            if (response.status === 401) {
                localStorage.removeItem(ACCESS_TOKEN);
                dispatch(logout());
                return { error: true };
            }
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.blob();
        })
        .catch((err) => {
            console.error(err);
        });
};
